module.exports = __webpack_public_path__ + "img/32.abe356f9.jpg";